import React from 'react';
import Seo from '../../components/Seo';
import PolicyHero from '../../components/PolicyHero';
import NewFooter from '../../components/NewFooter';
import './cookiepolicy.css';

const HERO_IMAGE = '/assets/images/cookies-policies.png';

function CookiePolicyPage() {
  return (
    <div className="ck-page">
      <Seo
        title="My Private Chemist | Cookie Policy"
        description="Learn how My Private Chemist uses cookies on our website, what data they collect, and how you can manage your cookie preferences."
        canonical={`${process.env.REACT_APP_BASE_URL}/cookie-policy`}
        url={`${process.env.REACT_APP_BASE_URL}/cookie-policy`}
        image={`${process.env.REACT_APP_BASE_URL}${HERO_IMAGE}`}
      />
      <PolicyHero
        title="Cookie Policy"
        pageName="Cookie Policy"
        heroImage={HERO_IMAGE}
      />

      <main className="ck-main">
        <div className="ck-content">
          <p>
            "Cookies" are pieces of code that a website transfers to your hard drive to store and
            sometimes track information about you. Cookies are common and won't do anything to harm
            your system – they simply store or gather information. They help our website function
            properly for you.
          </p>
          <p>
            We may collect information about your computer including, where available, your IP
            address, operating system and browser type for system administration as part of our audit
            trail process. Most web browsers automatically accept cookies, but if you prefer, you can
            change your browser to prevent that. You are not obliged to accept cookies and you can
            adjust your browser's setting to prevent it from accepting cookies on your computer – go
            to www.allaboutcookies.org for instructions on how to disable cookies. However, you may
            not be able to use our site fully.
          </p>
          <p>
            Cookies are specific to the server that created them and cannot be accessed by other
            servers, which means they cannot be used to track your movements around the web. Although
            they can be used to store information which may identify a user's computer, cookies do
            not personally identify users and passwords and credit card information are not stored in
            cookies.
          </p>
          <p>
            Our Website uses Per-Session cookies. We only use these whilst you are visiting our
            website and they are deleted when you leave. They remember you as you move between pages,
            for example recording the items you add to an online shopping basket or your prescription
            list. They also help maintain security.
          </p>
          <p>
            Our Website also uses Google Analytics cookies, to find out how people find our site,
            what content they look at and to gather customer journey information across our site to
            understand how people use the site and where we can improve it. We also use Google
            Analytics to collect aggregated statistics to describe traffic patterns, usage and other
            site information to prospective partners, suppliers, medical researchers, sponsors,
            investors and other reputable third parties and for other lawful purposes, but these
            statistics will include no personally identifying information.
          </p>
          <p>We will update this page to reflect any changes in cookies we use.</p>
        </div>
      </main>

      <NewFooter />
    </div>
  );
}

export default CookiePolicyPage;
